import { render, staticRenderFns } from "./CaTable.vue?vue&type=template&id=40aa6306&scoped=true&"
import script from "./CaTable.vue?vue&type=script&lang=js&"
export * from "./CaTable.vue?vue&type=script&lang=js&"
import style0 from "./CaTable.vue?vue&type=style&index=0&id=40aa6306&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40aa6306",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardText,VDataTable})
